<template>
  <div class="grid-container sm:justify-center">
    <div
      class="flex flex-col justify-center gap-4 w-full pt-6 md:pt-14 sm:col-[4_/_-4] md:col-[5_/_-5] xl:col-[4_/_-4]"
    >
      <div class="flex justify-end">
        <Link :href="$route('register')">
          <Button class="btn-tonal">¿Aún no tienes cuenta?</Button>
        </Link>
      </div>
      <div class="md:mx-12">
        <header>
          <h1 class="pb-2 headline-md md:headline-lg">Iniciar sesión</h1>
          <p class="title-md md:title-lg">
            ¡Hola de nuevo!
          </p>
        </header>
        <Alert
          v-if="errors.credentials"
          icon="error"
          class="mt-2 text-error !bg-error-container !border-error !p-4"
        >
          <!-- class="text-error bg-error-container border border-error rounded-2xl my-2 p-4" -->
          Credenciales incorrectas.
        </Alert>
        <form @submit.prevent="login" class="py-3">
          <TextInput
            id="email"
            v-model="form.email"
            type="email"
            label="Correo electrónico"
            placeholder="hi@example.com"
            icon="email-outline"
            class="pb-4"
            required
          />
          <TextInput
            id="password"
            v-model="form.password"
            type="password"
            label="Contraseña"
            icon="lock-outline"
            class="pb-2"
            required
          />
          <Link :href="$route('password.request')" class="btn-text-link !p-3 !max-w-fit"
            >Olvidé mi contraseña</Link
          >
          <Button type="submit" class="btn-filled block my-4 mx-auto" :isLoading="form.processing">
            Iniciar sesión
          </Button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue'
import Layout from '@/Layouts/Layout'
import Button from '@/Components/Button'
import TextInput from '@/Components/FormInputText'
import Alert from '@/Components/Alert'

export default {
  name: 'LogInApplicant',
  layout: Layout,
  props: {
    errors: Object,
  },
  components: {
    Link,
    Button,
    TextInput,
    Alert,
  },
  data() {
    return {
      form: this.$inertia.form({
        email: '',
        password: '',
      }),
    }
  },
  methods: {
    login() {
      this.form.post(this.$route('login.store'), {
        onError: errors => {
          this.$swal.fire({
            title: '¡Ocurrió un error!',
            text: 'Por favor, revisa los datos e intenta de nuevo.',
          })
        },
      })
    },
  },
}
</script>
